<template>
  <div class="banner">
    <mt-swipe :auto="4000">
      <mt-swipe-item v-for="(image, index) in img" :key="index">
        <img :src="image" alt=""/>
      </mt-swipe-item>
    </mt-swipe>
  </div>
</template>

<script>
import Vue from 'vue';
import {Swipe, SwipeItem} from 'mint-ui'
Vue.component(Swipe.name, Swipe);
Vue.component(SwipeItem.name, SwipeItem);
import 'mint-ui/lib/swipe/style.css'
export default {
  components:{
  },
  data(){
    return{
      img:[
        "http://www.cippe.com.cn/miniprogram/banner01.jpg",
        "http://www.cippe.com.cn/miniprogram/banner02.jpg",
        "http://www.cippe.com.cn/miniprogram/banner03.jpg",
        "http://www.cippe.com.cn/miniprogram/banner04.jpg"
      ]
    }
  },
  mounted() {
    
  },
};
</script>

<style scoped>
.banner img {
  height: auto;
  width: 100%;
}
.banner {
  margin-left: -10px;
  margin-right: -10px;
  overflow: hidden;
  height: 150px;
}
</style>